import React from 'react';
import { Trans } from 'react-i18next';

const CustomLoader = ({className, fontSize, message}) => {

  const s = {
    loader: {
      className: "text-center my-2" || className,
      style:{fontSize: "1.4em" || fontSize},
    },
  };

  return (
    <div className="custom-loader-overlay">
      <div {...s.loader}>
        <span className="fa fa-spinner fa-spin mt-2" /> {message ? <Trans>`${message}...`</Trans>:<Trans>Loading...</Trans>}
      </div>
    </div>
    
  );
};

export default CustomLoader;
